export interface AcccdItem {
  acccd: string;
  accnm: string;
}
